import React, { useContext, useMemo, useState } from 'react'

import { Modal, Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'
import { useSelector } from 'react-redux'

import { sendInternshipMessage } from '../../../utils/api/internshipMessage'
import { onError } from '../../../utils/apiHelper'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import useInternship from '../../../utils/api/hooks/useInternship'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'
import RejectionReasonsTabs, { OTHER_REJECTION_REASON } from './RejectionReasonsTabs'

const InternshipRejection = ({ internship, onRejection, onClose }) => {
  const ic = useContext(InstitutionContext)

  const rejectionReasons = useMemo(() => ic?.rejectionReasons ?? [], [ic?.rejectionReasons])

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [selectedReason, setSelectedReason] = useState(OTHER_REJECTION_REASON)
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)

  const internshipHandler = useInternship({ callback: onRejection })

  const handleCancel = (rejectionApproved = false) => {
    if (isFunction(onClose)) {
      onClose(rejectionApproved)
    }
  }

  const handleInternshipRejection = async () => {
    if (selectedReason === OTHER_REJECTION_REASON && comment.length === 0) {
      onError(t('Please complete your rejection reason.'))
      return
    }

    setLoading(true)

    const reasons = []

    if (selectedReason !== OTHER_REJECTION_REASON) {
      reasons.push(selectedReason)
    }

    internshipHandler.refuse(internship, reasons, comment).then(() => {
      let translatedComment = t('Internship refused') + ' : '

      if (selectedReason === OTHER_REJECTION_REASON) {
        translatedComment += comment
      } else {
        translatedComment += rejectionReasons.filter(rr => rr.id === selectedReason)[0].name
      }

      sendInternshipMessage(user, { internship: internship.id, content: translatedComment }).then(() => {
        setLoading(false)
        handleCancel(true)
      })
    })
  }

  return (
    <div>
      <Modal
        title={t('Refuse an internship')}
        visible={internship != null}
        onCancel={() => { handleCancel() }}
        footer={[
          <Button onClick={() => { handleCancel() }} key='cancel' type='default' loading={loading}>
            <FontAwesomeIcon icon={faTimes} />&nbsp;{t('Cancel')}
          </Button>,
          <Button onClick={handleInternshipRejection} key='save' type='primary' loading={loading}>
            <FontAwesomeIcon icon={faSave} />&nbsp;{t('Save')}
          </Button>
        ]}
      >
        <RejectionReasonsTabs
          selectedReason={selectedReason}
          comment={comment}
          onSelectedReasonChange={setSelectedReason}
          onCommentChange={setComment}
        />
      </Modal>
    </div>
  )
}

export default InternshipRejection
